import React from "react";
import { Route, Navigate, Routes } from 'react-router-dom';
import Layout from "./Layout/Layout";
import NetworkDetector from '../components/Hoc/NetworkDetector';
import Error from "../pages/error/Error";
import Login from "../pages/login/Login";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const App = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Navigate to="/app/dashboard" />} />
        <Route path="/app/*" element={<PrivateRoute component={Layout} />} />
        <Route path="/login" element={<PublicRoute component={Login} />} />
        <Route path="*" element={<Error />} />
      </Routes>
      <ToastContainer
        theme="colored"
        style={{ borderRadius: "50px" }}
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = window.sessionStorage.getItem('PKRD_Administration');
  return isAuthenticated ? <Component {...rest} /> : <Navigate to="/login" />;
};

const PublicRoute = ({ component: Component, ...rest }) => {
  return <Component {...rest} />;
};

export default NetworkDetector(App);
